import { render } from "./LoadoutManager.vue?vue&type=template&id=04e368ed"
import script from "./LoadoutManager.vue?vue&type=script&lang=js"
export * from "./LoadoutManager.vue?vue&type=script&lang=js"

import "./LoadoutManager.vue?vue&type=style&index=0&id=04e368ed&lang=scss"

import exportComponent from "/home/runner/work/MMXD_CardOptimizer/MMXD_CardOptimizer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__